import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import { Auth0Provider } from "@auth0/auth0-react";
import { connect } from "react-redux";
import AppLayout from "layouts/app-layout";
import { HelmetProvider } from "react-helmet-async";

//import Admin2FA from "./admin-2fa";
//import AppWABuddyLayout from "layouts/app-wa-buddy-layout";
import AuthLayout from "layouts/auth-layout";
import AppLocale from "lang";
import { IntlProvider } from "react-intl";
import { ConfigProvider } from "antd";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import useBodyClass from "hooks/useBodyClass";
import AuthProvider from "../context/Auth";
import PermissionsProvider from "../context/Permissions";
import Auth0Authentication from "../components/util-components/Auth0";
import SocketIO from "../components/util-components/SocketIO";

//import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

function RouteInterceptor({ children, isAuthenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH,
              state: { from: location },
            }}
          />
        )
      }
    />
  );
}

const Views = (props) => {
  // Initialize ReactQuery
  //https://tanstack.com/query/v4/docs/installation
  // const queryClient = new QueryClient();

  // const rollbar = useRollbar(); // <-- must have parent Provider
  // rollbar.info("Hello world!");
  //

  const { token, location, direction } = props;

  useBodyClass(`dir-${direction}`);

  const locale = "pt";

  const currentAppLocale = AppLocale[locale];

  return (
    <HelmetProvider>
      <IntlProvider locale={currentAppLocale.locale} messages={currentAppLocale.messages}>
        <ConfigProvider locale={currentAppLocale.antd} direction={direction}>
          <Auth0Provider
            domain={process.env.REACT_APP_AUTH0_URL}
            clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
            authorizationParams={{ redirect_uri: window.location.origin }}
            cacheLocation="localstorage"
          >
            <AuthProvider>
              <PermissionsProvider>
                <Auth0Authentication>
                  <Switch>
                    <Route exact path="/">
                      <Redirect to={"/dashboard"} />
                    </Route>

                    {/* <Route path="/admin-2fa" component={Admin2FA} /> */}

                    <Route path={AUTH_PREFIX_PATH}>
                      <AuthLayout direction={direction} />
                    </Route>

                    {/* {app === "wa-buddy" && (
                    <Route path={APP_PREFIX_PATH}>
                      <AppWABuddyLayout direction={direction} location={location} app="wa-buddy" />
                    </Route>
                  )}
                  {app === "wa-buddy" && (
                    <RouteInterceptor path={APP_PREFIX_PATH} isAuthenticated={token}>
                      <AppWABuddyLayout direction={direction} location={location} app="wa-buddy" />
                    </RouteInterceptor>
                  )} */}

                    <Route path={APP_PREFIX_PATH}>
                      <AppLayout direction={direction} location={location} />
                    </Route>

                    <RouteInterceptor path={APP_PREFIX_PATH} isAuthenticated={token}>
                      <AppLayout direction={direction} location={location} />
                    </RouteInterceptor>
                  </Switch>
                  <SocketIO />
                </Auth0Authentication>
              </PermissionsProvider>
            </AuthProvider>
          </Auth0Provider>
        </ConfigProvider>
      </IntlProvider>
    </HelmetProvider>
  );
};

const mapStateToProps = ({ theme, auth }) => {
  const { direction } = theme;
  const { token } = auth;
  return { token, direction };
};

export default withRouter(connect(mapStateToProps)(Views));
